import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    /** Prefix for id and aria-labelledby (e.g. "inventory" => inventory-tabpanel-0). */
    idPrefix: string;
    /** Padding for the content wrapper. Default: { py: 3 }. */
    contentSx?: SxProps<Theme>;
}

export default function TabPanel(props: TabPanelProps) {
    const { children, value, index, idPrefix, contentSx = { py: 3 }, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`${idPrefix}-tabpanel-${index}`}
            aria-labelledby={`${idPrefix}-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={contentSx}>{children}</Box>}
        </div>
    );
}
